module.exports = __webpack_public_path__ + "img/fi-rr-broom.89a14363.svg";